import React from "react";
import { toast } from "react-toastify";

const isInAppBrowser = () => {
  const ua = navigator.userAgent || navigator.vendor || window.opera;
  return (
    ua.includes("Instagram") ||
    ua.includes("FBAN") || // Facebook app
    ua.includes("FBAV") ||
    ua.includes("FB_IAB") ||
    ua.includes("Line") ||
    ua.includes("Twitter")
  );
};

const WorkItems = ({ item }) => {
  const hasDemo = Boolean(item.url);

  const handleClick = () => {
    // Project internal atau sudah tidak aktif: arahkan ke bagian kontak
    // daripada menampilkan pesan buntu.
    if (!hasDemo) {
      toast.info("This one is private — get in touch and I'll walk you through it.");
      document.getElementById("contact")?.scrollIntoView({ behavior: "smooth" });
      return;
    }

    if (isInAppBrowser()) {
      toast.info("Anda membuka dari aplikasi Instagram/FB. Untuk pengalaman terbaik, silakan buka demo ini di browser seperti Google Chrome.");
    }

    window.open(item.url, "_blank");
  };

  return (
    <div className="work__card" key={item.id}>
      <img src={item.image} alt="" className="work__img" />
      <h3 className="work__title">{item.title}</h3>
      {item.description && <p className="work__description">{item.description}</p>}
      <span className="work__button" onClick={handleClick}>
        {hasDemo ? "Demo" : "Request a walkthrough"} <i className="bx bx-right-arrow-alt work__button-icon"></i>
      </span>
    </div>
  );
};

export default WorkItems;
